import { sessionService, userService } from "./../services";
import { SyncSessionUseCase } from "./SyncSessionUseCase";

export const syncSessionUseCase = new SyncSessionUseCase(
  userService,
  sessionService
);
